import { gnosis, sepolia } from 'viem/chains';

export enum AllowedChain {
  Sepolia = 'sepolia',
  Gnosis = 'gnosis',
}
export const NETWORK_NAME = process.env
  .NEXT_PUBLIC_NETWORK_NAME as AllowedChain;

const VIEM_CHAIN_MAP = {
  [AllowedChain.Sepolia]: sepolia,
  [AllowedChain.Gnosis]: gnosis,
};

export const CHAIN = VIEM_CHAIN_MAP[NETWORK_NAME];

export const UPLOAD_API_URL =
  (process.env.NEXT_PUBLIC_STORAGE_BACKEND as string) + '/upload/';
